module.exports = __webpack_public_path__ + "img/sand-rock-big-15.cbf99bcc.png";